module.exports = __webpack_public_path__ + "media/newstyle/images/icon-lp-1-red-2cdb460a95510a6d308cdc72d36519aa.svg";